import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IPromise, IScope, ITimeoutService } from 'angular';

ProgramsCombosCreateController.$inject = ['$scope', '$state', '$timeout', 'ApiService', 'NoticeFactory'];

function ProgramsCombosCreateController(
  $scope: IScope & { programsCombosCreate: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  NoticeFactory: NoticeFactory
) {
  let transtionTimer: IPromise<void>;
  let navigateTimer: IPromise<void>;

  const ctrl = {
    model: {
      id: '',
    },
    componentType: 'comboEventTemplate',
    notice: new NoticeFactory(),

    init: function () {
      let title = { title: 'Create Combo' };

      if ($state.params && $state.params.comboId) {
        ctrl.model.id = $state.params.comboId;
        title = { title: 'Edit Combo' };
      }

      $scope.$emit('Application::contentTitleChange', title);

      $scope.$on('ProgramsCombosCreateController::reset', ctrl.onReset);
      $scope.$on('ProgramsCombosCreateController::error', ctrl.onError);
      $scope.$on('ProgramsCombosCreateController::success', ctrl.onSuccess);
      $scope.$on('ProgramsCombosCreateController::transition', ctrl.onTransition);
    },

    save: function (next) {
      $scope.$broadcast('ProgramsCombosCreateController::save', { state: next });
    },

    isActiveState: function (state: string) {
      const regex = new RegExp(state + '$');

      if ($state.current.name?.match(regex)) {
        return true;
      }

      return false;
    },

    success: {
      init: function (response) {},
    },

    error: {
      init: function (response) {},
    },

    onReset: function (e, data) {
      ctrl.notice.hideErrorMessages();
      ctrl.notice.hideSuccessMessages();
    },
    onError: function (e, data) {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.showErrorMessages([{ message: data.message }]);
    },
    onSuccess: function (e, data) {
      ctrl.notice.hideErrorMessages();
      ctrl.notice.showSuccessMessages([{ message: data.message }]);
    },

    onTransition: function (e, data) {
      if (transtionTimer) {
        $timeout.cancel(transtionTimer);
      }
      if (navigateTimer) {
        $timeout.cancel(navigateTimer);
      }
      transtionTimer = $timeout(() => {
        ctrl.notice.hideErrorMessages();
        ctrl.notice.hideSuccessMessages();

        navigateTimer = $timeout(() => {
          $state.go(data.state);
        }, 300);
      }, 3000);
    },
  };

  $scope.programsCombosCreate = ctrl;
  ctrl.init();
}

export const ProgramsCombosCreateControllerModule = angular
  .module('acme.view.application.programs.combos.create.controllers', [
    'acme.common.service.api',
    'acme.common.factory.notice',
  ])
  .controller('ProgramsCombosCreateController', ProgramsCombosCreateController).name;
